import { Component, OnInit } from '@angular/core';
import { ServiceManagerService } from '../service-manager.service';

import { HttpMethod } from '../../constants/constant';
import { HttpCustomOptions } from 'src/services/http-interceptor.service';
import * as jsonexport from 'jsonexport/dist';

@Component({
  selector: 'app-analytics',
  templateUrl: './analytics.component.html',
  styleUrls: ['./analytics.component.scss']
})
export class AnalyticsComponent implements OnInit {
  
  fileList = [
    {
      "fileName":"Analytics",
      "selected": false,
      "type": "all"
    },
  ]
  selectAllAnalytics:any = false;
  selectedAnalytics= [];
  constructor(public serviceManager: ServiceManagerService) { }

  ngOnInit(): void {
  }


  downloadAnalytics(){
    const customOptions : HttpCustomOptions = {
      showErrorMessage: true,
      showSuccessMessage: false,
      createLoaderAction: true
    }
    this.serviceManager.CallBackendServiceAPI('get-analytics', {}, HttpMethod.POST, customOptions).subscribe( (data: any)=>{
      var option:any = { headers: data['header'] }
      jsonexport(data['data'], option,(err: any, csv: string) => {
        if (err) {
          console.error(err);
        } else {
          this.downloadCsv(csv);
        }
      });
    }, (error: any) =>{
    })
  }
  downloadCsv(csv: string) {
    const blob = new Blob(['\ufeff', csv], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.setAttribute('href', url);
    link.setAttribute('download', 'analytics.csv');
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  updateAllAnalytics() {
    this.selectAllAnalytics = this.fileList.length && this.fileList.every((user: any) => user.selected);
  }

  checkSelectAll(): boolean {
    if (!this.fileList.length) {
      return false;
    }
    return this.fileList.filter((user : any)=> user.selected).length > 0 && !this.selectAllAnalytics;
  }

  setSelectAllAnalytics(selected: boolean) {
    this.selectAllAnalytics = selected;
    this.selectedAnalytics = []
    if (this.fileList == null) {
      return;
    }
    this.fileList.forEach((user: any) => (user.selected = selected))
  }

  disableDownload(){
    return this.fileList.length && this.fileList.every((user: any) => !user.selected);
  }
}
